module.exports = __webpack_public_path__ + "img/CATree3_Front.983f2d79.png";